import feather from "feather-icons";

document.cookie = 'post-protection=1; expires=' + (new Date(new Date().getTime() + (86400 * 7 * 1000))).toGMTString() + '; path=/; secure; samesite=none';

// Init sort items
$(document).ready(function() {
	'use strict';

	var sortControl = function ($this, event) {
		var sortableName, sortable, item, scrollable;

		if (typeof navigator === 'object' && typeof navigator.vibrate === 'function') {
			navigator.vibrate(35);
		}

		item = $this.parents('[data-type=item]');
		sortableName = item.parent().attr('id');
		scrollable = $('html, body');
		sortable = $.sortable(sortableName);
		sortable.activate(item,$this,scrollable,event.clientX,event.clientY);
	};


	if ('draggable' in document.createElement('span')) {
		$('[data-control=sort]').sortable(function (event) {sortControl($(this),event);});
	}
	else if (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
		$('[data-control=sort]').sortable(function (event) {sortControl($(this),event);});
	}
	else {
		$('[data-control=sort]').addClass('disabled');
	}
});


$(document).ready(function() {
	'use strict';


	$('[data-confirm]').click(function (event) {
		if (confirm($(this).data('confirm'))) {
			return true;
		}

		event.preventDefault();

		return false;
	});
});

$(document).ready(function () {
	feather.replace()
});